import React from 'react'
import ConfirmationModal from './ConfirmationModal'
import ActionButtons from '../Buttons/ActionButtons'
import { ContainedButtonVariant } from '../Buttons/ContainedButton'
import { TextButtonVariant } from '../Buttons/TextButton'
import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface DeclineInvitationModal {
  handleFormSubmit: (event: React.FormEvent<HTMLDivElement>) => void
  isOpen?: boolean
  handleCancel?: () => void
}

const DeclineInvitationModal: React.FC<DeclineInvitationModal> = ({
  isOpen = false,
  handleFormSubmit,
  handleCancel,
}) => {
  const { t } = useTranslation()

  return (
    <ConfirmationModal
      dialogActions={
        <ActionButtons
          primaryButtonLabel={ContainedButtonVariant.YesProceed}
          secondaryButtonLabel={TextButtonVariant.NoCancel}
          secondaryClick={handleCancel}
          alwaysStack
        />
      }
      dialogContent={
        <Typography variant="body1" component="p" align="center">
          {t(
            'DeclineInvitationModal.Content.Label',
            'You are about to skip some spots offered to your family. Please confirm this is intended before proceeding.'
          )}
        </Typography>
      }
      dialogTitle={t(
        'DeclineInvitationModal.Title.Label',
        'Offered Spots were Skipped'
      )}
      isOpen={isOpen}
      handleFormSubmit={handleFormSubmit}
    />
  )
}

export default DeclineInvitationModal
